export const groupChatsByDate = (chats) => {
  if (!Array.isArray(chats) || chats.length === 0) {
    return [];
  }
  
  const groups = [
    {
      title: "Today",
      key: 1,
      chats: []
    },
    {
      title: "Yesterday",
      key: 2,
      chats: []
    },
    {
      title: "Last 7 Days",
      key: 3,
      chats: []
    },
    {
      title: "Last 30 Days",
      key: 4,
      chats: []
    },
    {
      title: "Last 90 Days",
      key: 5,
      chats: []
    },
    {
      title: "Older",
      key: 6,
      chats: []
    }
  ];

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const startOfYesterday = startOfToday - (24 * 60 * 60 * 1000);
  const startOfLastWeek = startOfToday - (7 * 24 * 60 * 60 * 1000);
  const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()).getTime();
  const startOf3MonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate()).getTime();

  chats.forEach(chat => {
    if (!chat.messageDate) {
      console.error("Chat missing messageDate:", chat);
      return; 
    }

    const chatDate = new Date(chat.messageDate).getTime();
    
    if (isNaN(chatDate)) {
      console.error("Invalid date format:", chat.messageDate);
      return;
    }

    if (chatDate >= startOfToday) {
      groups[0].chats.push(chat);
    } else if (chatDate >= startOfYesterday) {
      groups[1].chats.push(chat);
    } else if (chatDate >= startOfLastWeek) {
      groups[2].chats.push(chat);
    } else if (chatDate >= startOfLastMonth) {
      groups[3].chats.push(chat);
    } else if (chatDate >= startOf3MonthsAgo) {
      groups[4].chats.push(chat);
    } else {
      groups[5].chats.push(chat);
    }
  });

  groups.forEach(group => {
    group.chats.sort((a, b) => {
      const dateA = new Date(a.messageDate).getTime();
      const dateB = new Date(b.messageDate).getTime();
      return dateB - dateA;
    });
  });

  return groups.filter(group => group.chats.length > 0);
};